import React from "react";
import { withApollo } from "@apollo/client/react/hoc";
import LoginRegistration from "screens/LoginRegistration";
import SLoader from "styled42/components/SLoader";
import { screenNames } from "screens/LoginRegistration/utils/constants";
import {
  createFlowCompletedCookie,
  isRegistrationIncomplete,
  getUserDetails
} from "screens/LoginRegistration/utils";
import { getToken } from "utils/authentication";
import { mLog } from "utils/logger";
import { GET_VARIANT } from "screens/JobList/query";
import { clientHelper } from "utils/graphQL";
import { activateGoogleOptimize } from "utils/googleOptimize";
import { DefaultTemplate } from "utils/googleOptimize/templates";
import { v4 as uuidv4 } from "uuid";
import config from "config";
import { retrieveDataFromAsyncStorage, storeDataToAsyncStorage } from "screens/common/utils";
import { hardRedirectTo } from "../lib/redirect";
import { getCookie, setCookie } from "../lib/session";
import Router from "../routes";

const isUserCompletelyLoggedIn = (req, res, user) => {
  const authToken = getToken(req);
  const flowCompleted = getCookie("flow_completed", req);
  if (!flowCompleted && !isRegistrationIncomplete(user)) {
    createFlowCompletedCookie(res)();
    return authToken;
  }
  return authToken && flowCompleted === "ajflowcompletev1";
};

const extractPathFromRoutes = (route, params) => {
  const { urls } = Router.findAndGetUrls(route, params);
  if (urls) return urls.as;
  return null;
};

const redirectToLoggedIn = (query, redirectToPage) => {
  let loggedInRoute = "/candidate-zone/dashboard/";

  if (query && query.route) {
    let actualParams = {};
    try {
      actualParams = JSON.parse(query.params);
    } catch (_) {}
    const myRoute = extractPathFromRoutes(query.route, actualParams);
    if (myRoute) loggedInRoute = myRoute;
  } else if (query && query.next) {
    loggedInRoute = query.next;
  }
  redirectToPage(loggedInRoute);
};

class LoginRegistrationWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageLoading: true,
      variant: ""
    };
  }

  static async getInitialProps({ req, res, query, apolloClient }) {
    const redirectToPage = hardRedirectTo(res); // hard redirect to allow cache reset and SW installation

    const authToken = getToken(req);
    let user = {};
    if (authToken) {
      const { data, error } = await getUserDetails({ apolloClient, authToken });
      if (error) {
        mLog("Got an error while fetching user data", error);
      } else {
        user = data.me;
      }
    }

    if (isUserCompletelyLoggedIn(req, res, user)) {
      redirectToLoggedIn(query, redirectToPage);
      return { redirecting: true };
    }

    const utmCookies = [
      "utm_source",
      "utm_page",
      "utm_medium",
      "utm_campaign",
      "http_referer",
      "utm_term",
      "utm_content",
      "gclid"
    ];
    const utmValues = utmCookies.map((name) => getCookie(name, req));
    const utmObject = utmCookies.reduce((obj, name, index) => {
      // eslint-disable-next-line
      obj[name] = utmValues[index];
      return obj;
    }, {});

    return {
      query,
      user,
      cookies: { utmParameters: utmObject },
      redirectToPage
    };
  }

  async componentDidMount() {
    // let variant = await activateGoogleOptimize(config.GA_ON_BOARDING_PHASE_4_EXP_ID, DefaultTemplate);
    // console.log("OnBoarding Variant :",variant);
    // variant = variant || "A"; // TODO: REMOVE DEFAULT VARIANT
    // console.log("OnBoarding Variant default :",variant);
    // storeDataToAsyncStorage("onboardingVariant", variant);
    
    const variant = await retrieveDataFromAsyncStorage("onboardingVariant");
    console.log("OnBoarding Variant :",variant);
    
    this.setState({
      variant,
      isPageLoading: false
    });
  }

  getInitialStateMachineProps = () => {
    const { query, cookies, redirectToPage, user } = this.props;
    const { variant } = this.state;
    let initialScreenName = "";
    const isRegistrationRequired = isRegistrationIncomplete(user, variant);
    let isNewUser = false;

    if (!user.id || !user.mobile) {
      initialScreenName = screenNames.LoginSignUpComponent;
    } else if (isRegistrationRequired) {
      initialScreenName = isRegistrationRequired;
      isNewUser = true;
    } else {
      createFlowCompletedCookie()(); // and now redirect
      redirectToLoggedIn(query, redirectToPage || hardRedirectTo(undefined));
      return { redirecting: true };
    }

    return {
      initialState: { user, query, cookies, isNewUser },
      initialScreenName
    };
  };

  render() {
    const { redirecting, user } = this.props;
    const { isPageLoading, variant } = this.state;

    if (redirecting || !user || isPageLoading) return <SLoader />;

    const {
      redirecting: newRedirecting,
      initialState,
      initialScreenName
    } = this.getInitialStateMachineProps();

    if (newRedirecting) return <SLoader />; // Don't load loginRegistration because it will delete the formed cookie!

    return (
      <LoginRegistration
        initialScreenName={initialScreenName}
        initialState={{ ...initialState, variant }}
      />
    );
  }
}

export default withApollo(LoginRegistrationWrapper);
